import { createSlice } from '@reduxjs/toolkit';
import { defaultApiState } from '../../../common/constants/api-constants';
import { ActionStatus } from '../../../common/constants/action-status';
import { fetchInstructorSampleOrders } from '../thunks/fetch-instructor-sample-orders.thunk';
import { MyAccountState } from './my-account.interface';

export const myAccountInitialState: MyAccountState = {
  instructorSampleOrders: defaultApiState,
};

export const myAccountSlice = createSlice({
  name: 'myAccount',
  initialState: myAccountInitialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchInstructorSampleOrders.pending, (state) => {
        state.instructorSampleOrders.status = ActionStatus.loading;
      })
      .addCase(fetchInstructorSampleOrders.fulfilled, (state, action) => {
        state.instructorSampleOrders.status = ActionStatus.succeeded;
        state.instructorSampleOrders.data = action.payload;
        state.instructorSampleOrders.error = undefined;
      })
      .addCase(fetchInstructorSampleOrders.rejected, (state, action: any) => {
        state.instructorSampleOrders.status = ActionStatus.failed;
        state.instructorSampleOrders.error = action.payload?.error;
        state.instructorSampleOrders.data = [];
      });
  },
});

export const myAccountReducer = myAccountSlice.reducer;
